import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
    return (
        <footer style={{
            backgroundColor: 'var(--bg-dark)',
            color: 'var(--text-main)',
            padding: '30px 0',
            marginTop: 'auto',
            borderTop: '1px solid var(--glass-border)'
        }}>
            <Container>
                <Row className="align-items-center justify-content-between">
                    <Col md={6} className="text-center text-md-start mb-2 mb-md-0">
                        <span style={{
                            fontSize: '0.9rem',
                            color: 'var(--text-muted)',
                            fontFamily: 'var(--font-body)'
                        }}>
                            &copy; 2025 Vintage Dealership. All Rights Reserved.
                        </span>
                    </Col>
                    <Col md={6} className="text-center text-md-end">
                        <span style={{
                            fontSize: '0.9rem',
                            color: 'var(--text-muted)',
                            fontFamily: 'var(--font-body)'
                        }}>
                            Powered by <span style={{ color: 'var(--highlight-gold)', fontWeight: 'bold' }}>RoBo Technologies</span>
                        </span>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
